<rt-offer-status-indicator [class.job]="info.stageName" [offerStatus]="$any(info)" />
<div>
  <span>
    {{ info.title }}
  </span>
  @if (info.stageName) {
    <strong>
      <i>&nbsp;/ {{ info.stageName }}</i>
    </strong>
  }
</div>
